export const CLIPBOARD_TOOLTIP_MESSAGE = 'Copy all error codes and Line Item IDs to the clipboard.';
export const ERRORS_BLOCK_TITLE = 'An error occurred when creating schedules for the following Line items:';
